import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './circle.less';

const Circle = ({ className }) => (
  <div className={classnames('loadingIndicatorCircle', className)} />
);

Circle.propTypes = {
  className: PropTypes.string,
};

export default Circle;
